<template>
  <div
    class="bulk-action-bar"
    role="toolbar"
    aria-label="Thanh thao tác hàng loạt"
    aria-live="polite"
  >
    <div class="bulk-action-bar__left">
      <p class="bulk-action-bar__title">
        <i class="fas fa-check-circle" aria-hidden="true"></i>
        Đã chọn <strong>{{ selectedCount }}</strong> hoá đơn
      </p>
      <p class="bulk-action-bar__hint">Chỉ các hoá đơn nháp mới có thể xóa hàng loạt.</p>
    </div>

    <div class="bulk-action-bar__right">
      <button
        type="button"
        class="bulk-action-bar__btn bulk-action-bar__btn--clear"
        :disabled="isLoading || isDeleteLoading"
        @click="$emit('clear-selection')"
      >
        <i class="fas fa-times" aria-hidden="true"></i>
        <span>Bỏ chọn</span>
      </button>

      <button
        type="button"
        class="bulk-action-bar__btn bulk-action-bar__btn--danger"
        v-if="draftCount > 0"
        :disabled="isDeleteLoading"
        :aria-busy="isDeleteLoading"
        :aria-label="isDeleteLoading ? 'Đang xóa hóa đơn nháp' : `Xóa hàng loạt ${draftCount} hóa đơn nháp`"
        @click="$emit('bulk-delete')"
      >
        <span v-if="isDeleteLoading" class="bulk-action-bar__spinner bulk-action-bar__spinner--danger" aria-hidden="true"></span>
        <i v-else class="fas fa-trash-alt text-white" aria-hidden="true"></i>
        <span>{{ isDeleteLoading ? 'Đang xóa...' : 'Xóa hàng loạt' }}</span>
        <span v-if="!isDeleteLoading && draftCount > 0" class="bulk-action-bar__badge bulk-action-bar__badge--danger">{{ draftCount }}</span>
      </button>

      <button
        type="button"
        class="bulk-action-bar__btn bulk-action-bar__btn--primary"
        :disabled="isLoading"
        :aria-busy="isLoading"
        @click="$emit('bulk-issue')"
      >
        <span v-if="isLoading" class="bulk-action-bar__spinner" aria-hidden="true"></span>
        <i v-else class="fas fa-file-invoice" aria-hidden="true"></i>
        <span>{{ isLoading ? 'Đang kiểm tra điều kiện...' : 'Phát hành hàng loạt' }}</span>
        <span v-if="!isLoading" class="bulk-action-bar__badge">{{ selectedCount }}</span>
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BulkActionBar',
    props: {
      selectedCount: {
        type: Number,
        default: 0,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      draftCount: {
        type: Number,
        default: 0,
      },
      isDeleteLoading: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['bulk-issue', 'clear-selection', 'bulk-delete'],
  }
</script>

<style scoped>
  .bulk-action-bar {
    position: sticky;
    top: 0.75rem;
    z-index: 30;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 0.75rem 1rem;
    margin-bottom: 0.75rem;
    background: #e1f0ff;
    border: 1px solid #b8daff;
    border-radius: 0.5rem;
    box-shadow: 0 4px 10px rgba(58, 87, 232, 0.1);
  }

  .bulk-action-bar__left {
    min-width: 0;
  }

  .bulk-action-bar__title {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    margin: 0;
    color: #3f4254;
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1.3;
  }

  .bulk-action-bar__title i {
    color: #187de4;
    font-size: 0.875rem;
  }

  .bulk-action-bar__title strong {
    color: #187de4;
    font-weight: 700;
    font-size: 0.9375rem;
    font-variant-numeric: tabular-nums;
  }

  .bulk-action-bar__hint {
    margin: 0.25rem 0 0;
    color: #464e5f;
    font-size: 0.75rem;
    line-height: 1.35;
  }

  .bulk-action-bar__right {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-shrink: 0;
  }

  .bulk-action-bar__btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.375rem;
    border: none;
    border-radius: 0.375rem;
    padding: 0.5rem 0.875rem;
    font-size: 0.8125rem;
    font-weight: 600;
    line-height: 1.2;
    cursor: pointer;
    transition: background-color 0.15s ease, color 0.15s ease, opacity 0.15s ease;
    white-space: nowrap;
  }

  .bulk-action-bar__btn:focus-visible {
    outline: 2px solid #3699ff;
    outline-offset: 2px;
  }

  .bulk-action-bar__btn:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  .bulk-action-bar__btn--clear {
    background: #f3f6f9;
    color: #464e5f;
  }

  .bulk-action-bar__btn--clear:hover:not(:disabled) {
    background: #e9edf3;
    color: #3f4254;
  }

  .bulk-action-bar__btn--danger {
    background: #f64e60;
    color: #fff;
  }

  .bulk-action-bar__btn--danger:hover:not(:disabled) {
    background: #e03045;
  }

  .bulk-action-bar__btn--danger:disabled {
    background: #b5b5c3;
  }

  .bulk-action-bar__btn--primary {
    background: #187de4;
    color: #fff;
  }

  .bulk-action-bar__btn--primary:hover:not(:disabled) {
    background: #0f6ecf;
  }

  .bulk-action-bar__btn--primary:disabled {
    background: #b5b5c3;
  }

  .bulk-action-bar__spinner {
    width: 14px;
    height: 14px;
    border: 2px solid rgba(255, 255, 255, 0.35);
    border-top-color: #fff;
    border-radius: 50%;
    animation: bulk-spin 0.8s linear infinite;
  }

  .bulk-action-bar__spinner--danger {
    border-color: rgba(255, 255, 255, 0.35);
    border-top-color: #fff;
  }

  @keyframes bulk-spin {
    to {
      transform: rotate(360deg);
    }
  }

  .bulk-action-bar__badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    height: 18px;
    padding: 0 6px;
    border-radius: 9px;
    background: rgba(255, 255, 255, 0.25);
    font-size: 0.6875rem;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
  }

  .bulk-action-bar__badge--danger {
    background: rgba(255, 255, 255, 0.3);
  }

  @media (max-width: 767.98px) {
    .bulk-action-bar {
      flex-direction: column;
      align-items: stretch;
      gap: 0.75rem;
      padding: 0.75rem;
    }

    .bulk-action-bar__right {
      width: 100%;
      justify-content: flex-end;
    }

    .bulk-action-bar__btn {
      min-height: 36px;
    }

    .bulk-action-bar__btn--danger,
    .bulk-action-bar__btn--primary {
      flex: 1;
    }
  }
</style>
